// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1lXFF","actions":"GroupTable_actions__24gZG","deleteModalFooter":"GroupTable_deleteModalFooter__2reqH"};